import { useState } from 'react';
import QRCode from 'react-qr-code';
import { ReclaimProofRequest } from '@reclaimprotocol/js-sdk';
import './App.css';

function App() {
  const [requestUrl, setRequestUrl] = useState('');
  const [proofs, setProofs] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [reclaimConfig, setReclaimConfig] = useState(null);
  const generateConfig = async () => {
    setLoading(true);
    setError(null);
    try {
      

// 2. Continue with ReclaimProofRequest as before
const reclaimProofRequest = await ReclaimProofRequest.init(
  '0x991359364b67a3DCdB42EE03E5946f4c97aE139f',
  '0x64936dfd757fbea7b6011564475215a2c9c91d34a27d608fa42a3ed9af523970',
  'example'
);
setReclaimConfig(reclaimProofRequest)

    } catch (err) {
      console.error('Error:', err);
      setError('Failed to initialize Reclaim: ' + err.message);
      setLoading(false);
    }
  };


  const openAppClip = async () => {
    try {
      // App Clip uses the apple-app-site-association (AASA) file, not "amp-app", to fetch App Clip metadata.
      // If the App Clip session doesn't start on the first try, wait 2 seconds and try again.
      // Note: App Clip session start can't be tracked programmatically.
      // We can only attempt to trigger the session.
        await reclaimConfig.triggerReclaimFlow();
        await new Promise(resolve => setTimeout(resolve, 2000));
        await reclaimConfig.triggerReclaimFlow();
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to initialize Reclaim: ' + err.message);
      setLoading(false);
    }
  };
  return (
    <div className="App">
      <header className="App-header">
        <h1 style={{
          fontSize: '2.5rem',
          color: '#ffffff',
          marginBottom: '2rem',
          fontWeight: '600',
          letterSpacing: '-0.5px'
        }}>Reclaim Protocol Demo</h1>
        <div className="playground-container" style={{
          backgroundColor: '#1a1a1a',
          boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2rem'
          }}>
            <button 
              onClick={generateConfig}
              disabled={loading}
              className="test-button"
              style={{
                minWidth: '250px',
                backgroundColor: '#ffffff',
                color: '#000000',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}
            >
              {loading ? (
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <div className="spinner"></div>
                  <span>Generating...</span>
                </div>
              ) : 'Generate Verification Request'}
            </button>
            {
              reclaimConfig && (
            
            <button 
              onClick={openAppClip}
              id='open-clip-button'
              className="open-clip-button"
              style={{
                minWidth: '250px',
                backgroundColor: '#ffffff',
                color: '#000000',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}
            >
              Open App Clip
            </button>
              )}

            {error && (
              <div className="error-message" style={{
                width: '100%',
                maxWidth: '500px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: '#ffffff'
              }}>
                {error}
              </div>
            )}
          
          {
            JSON.stringify(reclaimConfig)
          }
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
